<template>
    <div>
        <div class="page-top mb-1 mb-3">
			<h1 class="float-left mt-2"> Add New Campus/Branch </h1>
			<a href="#" class="btn btn-primary float-right ml-1"> Cancel </a>
			<a @click="addFeeCampusData" class="btn btn-primary float-right active"> Save & Continue </a>
        </div>
		<div class="row normal-ib-space">
			<div class="col-md-12">
				<ul class="page-status collections-page-status align-left pt-0">
					<li class="page-status-list active">
						<span class="status-highlighter">1</span>
						Branch Detail
					</li>
					<li class="page-status-list">
						<span class="status-highlighter">2</span>
						Add Students
					</li>
					<li class="page-status-list">
						<span class="status-highlighter">3</span>
						Confirmation Messgae
					</li>
				</ul>
			</div>
		</div>
		<div class="content-box add-new-branch-detail p-5">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<input v-model="form.name" id="name" name="name" type="text" class="form-control" placeholder="Campus/Branch Name"  :class="{ 'is-invalid': form.errors.has('name') }" />
                        <has-error :form="form" field="name"></has-error>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
                        <input v-model="form.campus_code" type="text" name="campus_code" class="form-control" placeholder="Campus/Branch Code" :class="{ 'is-invalid': form.errors.has('campus_code') }">
                        <has-error :form="form" field="campus_code"></has-error>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<span class="title"> Type:</span>
						<label class="radio-holder mb-0">
							Owned
							<input type="radio" name="check" value="OWNED" checked="" v-model="form.campus_type">
							<span class="checkmark"></span>
						</label>
						<label class="radio-holder mb-0">
							Franchise
							<input type="radio" name="check" value="FRANCHISE"  v-model="form.campus_type">
							<span class="checkmark"></span>
						</label>
                        <has-error :form="form" field="campus_type"></has-error>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
                        <select v-model="form.status" name="status" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                            <option value="" selected>Select Status</option>
                            <option value="ENABLED">Enabled</option>
                            <option value="DISABLED">Disabled</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
                        <select class="selectpicker custom-select2" v-model="form.city_id" :class="{ 'is-invalid': form.errors.has('city_id') }">
                            <option value=""> Select City </option>
                            <template v-if="cities != null">
                                <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
                            </template>
                        </select>
                        <has-error :form="form" field="city_id"></has-error>						
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<input id="address" name="address" type="text" class="form-control" placeholder="Address" v-model="form.address" :class="{ 'is-invalid': form.errors.has('address') }" />
                        <has-error :form="form" field="address"></has-error>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    city_id : '',
                    campus_type : '',
                    name : '',
                    campus_code : '',
                    address : '',
                    status : '',
                }),
                cities : null
            }
        },
        methods: {
            addFeeCampusData() {
                this.$Progress.start();
                this.form.post('api/addFeeCampus')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Campus/Branch created successfully');
                        this.$router.push('/feeAddCampusStudents/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in you form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            getAddFeeCampusData(){
                this.$Progress.start();
                axios.get('api/getCampusData')
                    .then(result => {
                        this.cities = result.data.cities;
                        this.$Progress.finish();
                    })
                    .then(result => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        this.$Progress.fail();
                    });
            },
        },
        created() {
            this.getAddFeeCampusData();
        },
    }
</script>
